import PropTypes from 'prop-types';
import React from 'react';
import { Body2 } from '../../../../../../atomic/text/Text';
import style from './TopRowBox.module.css';

export const TopRowBox = ({
  children,
  color,
  backgroundColor,
  width,
  justifyContent,
}) => {
  return (
    <div className={style.box} style={{ backgroundColor, width, justifyContent }}>
      <Body2 maxWidth="100%" fontWeight={700} color={color}>{children}</Body2>
    </div>
  );
};

TopRowBox.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  width: PropTypes.string,
  justifyContent: PropTypes.string
};
